import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';

// The real session lives in an httpOnly cookie the server sets on login (never readable
// from JS, never in a URL). This key only stores a UI hint so the app knows whether to
// show the "logged in" state / hidden category without needing to ask the server.
export const LOGGED_IN_KEY = 'yts_logged_in';

const LoginPage: React.FC = () => {
  const history = useHistory();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);
    setLoading(true);
    try {
      const res = await fetch('/api/login', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password })
      });
      const data = await res.json();
      if (!res.ok) {
        setError(data.error || '登入失敗');
        return;
      }
      localStorage.setItem(LOGGED_IN_KEY, '1');
      history.push('/');
    } catch (e) {
      setError('網絡錯誤，請重試');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ maxWidth: 360, margin: '60px auto', padding: '32px', textAlign: 'center' }}>
      <h2 style={{ color: 'var(--main-coffee)', marginBottom: 24 }}>登入</h2>
      <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 14 }}>
        <input
          type="text"
          placeholder="用戶名"
          value={username}
          onChange={e => setUsername(e.target.value)}
          autoComplete="username"
          style={{ padding: '10px 12px', border: '1px solid var(--main-coffee-light)', borderRadius: 6, fontSize: '1rem' }}
        />
        <input
          type="password"
          placeholder="密碼"
          value={password}
          onChange={e => setPassword(e.target.value)}
          autoComplete="current-password"
          style={{ padding: '10px 12px', border: '1px solid var(--main-coffee-light)', borderRadius: 6, fontSize: '1rem' }}
        />
        {error && <div style={{ color: 'red', fontSize: '0.9rem' }}>{error}</div>}
        <button
          type="submit"
          disabled={loading || !username || !password}
          style={{ padding: '10px 12px', background: 'var(--main-coffee)', color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer', fontSize: '1rem' }}
        >
          {loading ? '登入中...' : '登入'}
        </button>
      </form>
    </div>
  );
};

export default LoginPage;
